import { getState, subscribe } from './state/appState';
import { renderApp } from './ui/renderApp';
import { logger } from './utils/logger';

// Application entry point.
// Mounts the app into #app and subscribes to state changes so the
// UI stays in sync with the state machine throughout the experience.

function mount(): void {
  const root = document.getElementById('app');
  if (!root) {
    logger.error('#app mount point not found');
    return;
  }

  // Initial render.
  renderApp(root, getState());

  // Re-render whenever state changes.
  subscribe((state) => {
    renderApp(root, state);
  });

  logger.log('App mounted, initial state:', getState());
}

mount();
